<template>
  <div class="developers">
    <h4>{{ $t('Наименование') }}</h4>
    <ul class="developer-list" v-show="showArchive === false" v-if="successorDevelopers.length > 0">
      <li
        v-for="developer in successorDevelopers"
        :key="developer.developer.id"
      >
        <router-link
          active-class="active"
          :to="$i18nRoute({ name: 'search-npa', query: { developer: developer.developer.id } })"
          :title="developer.developer.departmentsForTitle"
        >
          <v-icon
            class="nv_icon mr-1"
            v-if="developer.developer.status === false"
            x-small
          />
          {{ developer.developer.transName }}
        </router-link>
        <div v-if="developer.children && developer.children.length > 0">
          <a
            class="show-child-developer child-toggle-link"
            v-show="!showChildren[developer.developer.id]"
            @click="showChildren[developer.developer.id] = true">
            {{ $t('Показать') }} ({{ developer.children.length }})
          </a>
          <a
            class="hide-child-developer child-toggle-link"
            v-show="showChildren[developer.developer.id]"
            @click="showChildren[developer.developer.id] = false">
            {{ $t('Скрыть') }} ({{ developer.children.length }})
          </a>
          <div v-show="showChildren[developer.developer.id]" class="dev-children">
              <span
                v-for="child in developer.children"
                :key="child.id"
              >
                <router-link
                  :to="$i18nRoute({
                    name: 'search-npa',
                    query: { developer: child.id }
                  })"
                >
                  <v-icon
                    class="nv_icon mr-1"
                    v-if="child.status === false"
                    x-small
                  />
                  {{ child.transName }}
                </router-link>
              </span>
          </div>
        </div>
      </li>
    </ul>
    <ul class="developer-list" v-show="showArchive === true" v-if="developers.length > 0">
      <li
        v-for="developer in developers"
        :key="developer.developer.id"
      >
        <router-link
          active-class="active"
          :to="$i18nRoute({ name: 'search-npa', query: { developer: developer.developer.id } })"
          :title="developer.developer.departmentsForTitle"
        >
          <v-icon
            class="nv_icon mr-1"
            v-if="developer.developer.status === false"
            x-small
          />
          {{ developer.developer.transName }}
        </router-link>
        <div v-if="developer.children && developer.children.length > 0">
          <a
            class="show-child-developer child-toggle-link"
            v-show="!showChildren[developer.developer.id]"
            @click="showChildren[developer.developer.id] = true">
            {{ $t('Показать') }} ({{ developer.children.length }})
          </a>
          <a
            class="hide-child-developer child-toggle-link"
            v-show="showChildren[developer.developer.id]"
            @click="showChildren[developer.developer.id] = false">
            {{ $t('Скрыть') }} ({{ developer.children.length }})
          </a>
          <div v-show="showChildren[developer.developer.id]" class="dev-children">
              <span
                v-for="child in developer.children"
                :key="child.id"
              >
                <router-link
                  :to="$i18nRoute({
                    name: 'search-npa',
                    query: { developer: child.id }
                  })"
                >
                  <v-icon
                    class="nv_icon mr-1"
                    v-if="child.status === false"
                    x-small
                  />
                  {{ child.transName }}
                </router-link>
              </span>
          </div>
        </div>
      </li>
    </ul>
    <a
      v-show="showArchive === true"
      @click="showArchive = false"
      v-if="successorDevelopers.length > 0"
    >
      {{ $t('Разработчики') }}
    </a>
    <a
      v-show="showArchive === false"
      @click="showArchive = true"
      v-if="developers.length > 0"
    >
      {{ $t('Архив разработчиков') }}
    </a>
  </div>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    developers: [],
    successorDevelopers: [],
    showChildren: {},
    showArchive: false
  }),
  created() {
    CMS.getNpaDeveloper()
      .then((response) => {
        this.developers = response.data.items
        this.successorDevelopers = response.data.successorItems
        let self = this
        this.developers.forEach(function(developer) {
          self.$set(self.showChildren, developer.developer.id, false)
        })
        this.successorDevelopers.forEach(function(developer) {
          self.$set(self.showChildren, developer.developer.id, false)
        })
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>

<style>
.developers {
  transition: all 0.2s;
}

.developer-list {
  padding: 0 !important;
}

.slide-right-leave-to {
  opacity: 0;
  transform: translate(30px, 0);
}

.slide-right-enter {
  opacity: 0;
  transform: translate(-30px, 0);
}

.child-toggle-link {
  display: inline-block;
  cursor: pointer;
}

.developers .child-toggle-link {
  color: #0069bb !important;
  text-decoration: underline !important;
}

.developers .child-toggle-link:hover {
  color: #00508f !important;
}
</style>
